import { NgModule } from '@angular/core';

import { SharedModule } from '@shared';

import { DataListingRequestModalComponent } from './modals/data-listing-request-modal/data-listing-request-modal.component';
import { EnableMfaModalComponent } from './modals/enable-mfa-modal/enable-mfa-modal.component';
import { EnableMfaModalService } from './modals/enable-mfa-modal/enable-mfa-modal.service';
import { SoftDeleteAccountModalComponent } from './modals/soft-delete-account-modal/soft-delete-account-modal.component';

@NgModule({
  declarations: [EnableMfaModalComponent, SoftDeleteAccountModalComponent, DataListingRequestModalComponent],
  imports: [SharedModule],
  providers: [EnableMfaModalService],
})
export class UserSettingsModalsModule {}
